export default __webpack_public_path__ + "static/nar-bruker-vi-illustrasjoner-1d4d8752784307f73c014f5dd6d9e4fd.png";